import { Component, OnInit } from '@angular/core';
import { NgFor } from '@angular/common';
import { CardInfoDetailV2Component } from '@commons/card-info-detail-v2/card-info-detail-v2.component';

@Component({
    selector: 'activities-information-disney',
    templateUrl: './activities-information.component.html',
    styleUrls: ['./activities-information.component.scss'],
    standalone: true,
    imports: [CardInfoDetailV2Component],
})
export class ActivitiesInformationDisneyComponent implements OnInit {
  private lessText = `Para todas las actividades y beneficios
  con límite de edad, se tomará en cuenta la edad
  al momento de finalizar la estadía.`;

  private moreText = `Consideramos 'Bebés' a niños de 0 a 3 años, 'Menores' a niños de 3 a 17 años
      inclusive, y 'Mayores' a todos aquellos de 18 años en adelante.`;

  public arrayText = [];
  constructor() {
    this.arrayText = [this.lessText];
  }

  ngOnInit() {}

  onClickViewMoreLess(more: boolean) {
    if (more) {
      this.arrayText = [this.lessText, this.moreText];
    } else {
      this.arrayText = [this.lessText];
    }
  }
}
